import React from "react";
import { PROCESS_STAGES } from "../../data/process";
import { Reveal } from "../ui/Reveal";

/** Compact 4-stage timeline used on Home and service pages. */
export function ProcessTimeline() {
  return <ol className="grid gap-px overflow-hidden rounded-[clamp(1rem,1.2vw,1.5rem)] border border-line bg-line md:grid-cols-2 xl:grid-cols-4" data-id="element-419" data-mp="3ufo0t50uczff">
      {PROCESS_STAGES.map((s, i) => <Reveal as="li" key={s.id} delay={i * 0.05} className="relative flex flex-col bg-ink p-[clamp(1.5rem,2.2vw,2.75rem)]" data-id="element-420" data-mp="3lfhj16y41dag" data-mpi={i}>
          <span className="font-mono text-sm text-accent-soft" data-id="element-421" data-mp="3gnzp32ui8cyz">Stage {i + 1}</span>
          <div className="my-6 flex items-center gap-3" aria-hidden data-id="element-422" data-mp="3bp6cdcn1kpzv">
            <span className="h-3 w-3 rounded-full border-2 border-accent bg-ink" data-id="element-423" data-mp="36qv2x30nshi6" />
            <span className="h-px flex-1 bg-line-strong" data-id="element-424" data-mp="36os4bulfxg1u" />
          </div>
          <h3 className="t-h3" data-id="element-425" data-mp="32oqag7ly5qx4">{s.title}</h3>
          <p className="t-body mt-3 text-muted" data-id="element-426" data-mp="2xq6ldyc23z0j">{s.summary}</p>
        </Reveal>)}
    </ol>;
}